import React, { useState } from 'react';

import Header from '../components/header';
import PricingCard from '../components/PricingCard';
import Faq from '../components/Faq';
import Footer from '../components/Footer';
import { useMediaQuery } from 'react-responsive';
import SidebarHeader from '../components/sidebarHeader';
import { HiLink } from 'react-icons/hi';
import { MdPayment, MdWebStories } from 'react-icons/md';
import { NavLink } from 'react-router-dom';

const BecomePartener = () => {
  const [pack, setPack] = useState(false);
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1150px)' });
  const [menu, setMenu] = useState("");

  return (
   <>
      {isDesktopOrLaptop ? <Header menu={menu} setMenu={setMenu} /> : <SidebarHeader />}
      <div onMouseOver={() => setMenu("")} className="text-black">
      <section className="my-8 flex text-center h-[500px] bg-purple-600 text-white p-8 rounded-lg">
        <div className='flex flex-col justify-center items-start w-[800px]  mx-auto '>
        <h2 className="text-6xl text-left font-bold mb-4">Join Maker4u Affiliate Program Now</h2>
        <p className='text-xl text-left mb-[50px]'>Maker4u affiliate program is available on both ShareASale and Impact networks. Free for you to choose one or both to join.</p>
        <button className="bg-white text-gray-800 text-lg font-bold text-purple-600 px-4 py-2 mt-4 rounded-full">Start Earning </button>
        </div>
        <div className='w-[500px]'>
            <img src='/assets/herosection.png' className='w-[400px]'></img>
        </div>
      </section>

      {/* Earn Money Section */}
      <h2 className="text-4xl font-bold text-center mb-4">Earn Money with Maker4u</h2>
      <section className="my-8 flex items-center justify-center">
      
      <div className="container mx-auto flex flex-col md:flex-row items-center py-[70px]">
        <div className="md:w-1/2 flex justify-center">
          <img src="/assets/commission.png" alt="Earning Money" className='w-[400px]'></img>
        </div>
        <div className="md:w-1/2 p-6 flex flex-col justify-start text-center px-[100px] text-left">
          <h3 className="text-2xl font-semibold mb-2 ">Earn up to 60% Commission.</h3>
          <p className='text-xl'>For each new Maker4u Pro subscriber who signs up using your exclusive referral link, you might get up to 60% in compensation. Regular and flexible payment options are available.</p>
        </div>
      </div>
    </section>

      {/* Program Description Section */}
      <section className="my-8 flex items-center justify-center py-[70px]">
      <div className="container mx-auto flex flex-col  md:flex-row justify-center items-center">
        <div className="md:w-1/2 p-6 text-center px-[100px] text-left">
          <h3 className="text-2xl font-semibold mb-2 ">Get at much as $5000 a month!</h3>
          <p className='text-xl'>Earn high commissions by helping to grow Maker4u's global user base.</p>
        </div>
        <div className="md:w-1/2 flex justify-center">
          <img src="/assets/money.png" alt="Earning Money" className='w-[500px]'></img>
        </div>
      </div>
    </section>

      {/* How It Works Section */}
      <section className="my-16 text-center">
  <h2 className="text-3xl font-bold mb-8">How it works?</h2>
  <div className="flex  md:flex-row justify-around items-start space-y-8 md:space-y-0 md:space-x-2">
    <div className="md:w-1/3 p-4">
      <div className="border-[1px] border-purple-500 shadow-lg rounded-lg p-6 h-[200px] flex flex-col justify-center items-center transform transition duration-300 hover:scale-105">
        <HiLink className='text-6xl font-bold mb-2 text-purple-600'/>
        <h3 className="text-2xl font-bold mb-2 text-purple-600">Become Partener</h3>
        <p className="text-lg text-gray-800">Register quickly and start promoting.</p>
      </div>
    </div>
    <div className="md:w-1/3 p-4">
      <div className="border-[1px] border-purple-500 shadow-lg rounded-lg p-6 h-[200px] flex flex-col justify-center items-center transform transition duration-300 hover:scale-105">
        <MdWebStories className='text-6xl font-bold mb-2 text-purple-600'/>
        <h3 className="text-2xl font-bold mb-2 text-purple-600">Design Template</h3>
        <p className="text-lg text-gray-800">Integrate Maker4u promotional content easily.</p>
      </div>
    </div>
    <div className="md:w-1/3 p-4">
      <div className="border-[1px] border-purple-500 shadow-lg rounded-lg p-6 h-[200px] flex flex-col justify-center items-center transform transition duration-300 hover:scale-105">
        <MdPayment className='text-6xl font-bold mb-2 text-purple-600'/>
        <h3 className="text-2xl font-bold mb-2 text-purple-600">Receive your income!</h3>
        <p className="text-lg text-gray-800">Start earning commissions effortlessly.</p>
      </div>
    </div>
  </div>
</section>


      {/* Final Call-to-Action Section */}
      <section className="my-16 text-center">
  <h2 className="text-3xl font-bold mb-8">Become a Maker4u Affiliate Partner Today And Start Earning!</h2>
  <NavLink
              to={`https://adminpanel.maker4u.com/`}
              className="hover:no-underline"
            >
  <button className="bg-gradient-to-r from-purple-500 to-purple-500 text-white px-6 py-3 mt-4 rounded-full shadow-lg transform transition duration-300 hover:scale-105">
    Join us now
  </button>
  </NavLink>
</section>

        <footer>
          <Footer />
        </footer>
      </div>
      </>
  );
};

export default BecomePartener;